import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Form, FormGroup } from 'reactstrap';
import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import {
  isRequired,
  validateNumber,
} from '../../../../utils/validators';
import DynamicForm from '../../../common/forms/DynamicForm';
import FormFooter from '../../../common/forms/FormFooter';
import { DRIVER_COMMISSION_FORM_COLUMNS } from '../../../../config/dynamicFormFields';
import Loader from '../../../common/Loader';

const DriverCommissionForm = ({ handleSubmit, loading }) => {
  if (loading) return <Loader />;
  return (
  <Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label="Nombre" required>
        <Field
          name="name"
          component={TextInput}
          type="text"
          placeholder="Nombre"
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Descripción" required>
        <Field
          name="description"
          component={TextInput}
          type="textarea"
          placeholder="Descripción"
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Base" required>
        <Field
          name="baseCommission"
          component={TextInput}
          type="number"
          placeholder="Base"
          validate={[isRequired, validateNumber]}
        />
      </FormItem>
    </FormGroup>
    <DynamicForm
      title="Rangos de Condición de Trabajo"
      name="driverCommissionRangeList"
      columns={DRIVER_COMMISSION_FORM_COLUMNS}
    />
    <FormFooter />
  </Form>
);
}

DriverCommissionForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

DriverCommissionForm.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ HumanResourcesUnit }) => ({
  loading: !HumanResourcesUnit.DriverCommission.getIn([
    'current',
    'activity',
  ]).isEmpty(),
})

const form = reduxForm({
  form: 'DriverCommissionForm',
})(DriverCommissionForm);

export default connect(mapStateToProps)(form);